<template>
    <div class="page">
        <div class="rule-content">
            <h2>{{title}}</h2>
            <div v-html="content"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Doc',
    data(){
        return {
            referer: '',
            title: '',
            content: '',
        }
    },
    beforeRouteEnter (to, from, next){
        next(vm => {
            vm.referer = from.name
        })
   },
    computed: {
        ...mapState(['lang'])
    },
    created(){
        Utils.$ajax({
            url: '/share/privacy',
        }).done(res =>{
            if (res.code != 0){
                this.$toast(res.msg);
                return;
            }
            this.title = res.data.title;
            this.content = res.data.content;
        })
    },
    methods: {
        _startAn(){
            this.$router.push(`/answer`);
        },
    }
}
</script>

<style lang="scss" scoped>
    .page{
        background: #fff;
        height: 100%;
        padding: 2em 3em;
        min-height: rem(1020);
    }
    .rule-content{
        color: #000;
        padding-bottom: 20px;
        h2{
            font-size: rem(36);
            font-weight: bold;
        }
        p{
            margin: .5em 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue